function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ans_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "ans_svg__a",
  d: "M0-61h181.812v53.474H0z",
  transform: "translate(0 61)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ans_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "ans_svg__a",
  d: "M8.133-52.867h167.553v39.214H8.133z",
  transform: "translate(-8.133 52.867)"
})), /*#__PURE__*/React.createElement("style", null, ".ans_svg__a{fill:none;clip-rule:evenodd}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ans_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-4.383-4.383h190.579v62.241H-4.383z",
  fill: "#0d0d0d"
}));

var _ref3 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(42.836 29.701)",
  fill: "#fff",
  fontSize: 11,
  fontFamily: "Montserrat-SemiBold,Montserrat",
  fontWeight: 600
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "ANS - N\xB0 421049"));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.486 7.13)",
  clipPath: "url(#ans_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h167.553v39.214H0z",
  stroke: "#fff",
  strokeWidth: 2.711,
  fill: "none"
}));

function SvgAns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181.813,
    height: 53.474
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTgxLjgxMyIgaGVpZ2h0PSI1My40NzQiIHZpZXdCb3g9IjAgMCAxODEuODEzIDUzLjQ3NCI+PGRlZnM+PHN0eWxlPi5hLC5me2ZpbGw6bm9uZTt9LmF7Y2xpcC1ydWxlOmV2ZW5vZGQ7fS5ie2NsaXAtcGF0aDp1cmwoI2EpO30uY3tmaWxsOiMwZDBkMGQ7fS5ke2ZpbGw6I2ZmZjtmb250LXNpemU6MTFweDtmb250LWZhbWlseTpNb250c2VycmF0LVNlbWlCb2xkLCBNb250c2VycmF0O2ZvbnQtd2VpZ2h0OjYwMDt9LmV7Y2xpcC1wYXRoOnVybCgjYik7fS5me3N0cm9rZTojZmZmO3N0cm9rZS13aWR0aDoyLjcxMXB4O308L3N0eWxlPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggY2xhc3M9ImEiIGQ9Ik0wLTYxSDE4MS44MTJWLTcuNTI2SDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDYxKSIvPjwvY2xpcFBhdGg+PGNsaXBQYXRoIGlkPSJiIj48cGF0aCBjbGFzcz0iYSIgZD0iTTguMTMzLTUyLjg2N0gxNzUuNjg2djM5LjIxNEg4LjEzM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04LjEzMyA1Mi44NjcpIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xhc3M9ImIiPjxwYXRoIGNsYXNzPSJjIiBkPSJNLTUtNjZIMTg1LjU3OVYtMy43NTlILTVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjYxNyA2MS42MTcpIi8+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQyLjgzNiAxOC43MDEpIj48dGV4dCBjbGFzcz0iZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxMSkiPjx0c3BhbiB4PSIwIiB5PSIwIj5BTlMgLSBOwrAgNDIxMDQ5PC90c3Bhbj48L3RleHQ+PC9nPjxnIGNsYXNzPSJlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjQ4NiA3LjEzKSI+PHBhdGggY2xhc3M9ImYiIGQ9Ik0wLDBIMTY3LjU1M1YzOS4yMTRIMFoiLz48L2c+PC9zdmc+";
export { SvgAns as ReactComponent };